module.exports = __webpack_public_path__ + "img/1.f7030238.png";